var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262929",
    fillRule: "evenodd",
    d: "M0 18.3a1 1 0 0 0 1.486.875l14.94-8.3a1 1 0 0 0 0-1.75L1.487.826A1 1 0 0 0 0 1.7z",
    clipRule: "evenodd"
  })));
};
export default SvgTriangle;